module.exports = __webpack_public_path__ + "img/makieta-mobile.d3a98538.jpg";